import React from "react";
import { Grid } from "@material-ui/core";

import "./style.css";
import LayoutTemplate from "../../../components/common/layout-template";
import TotalSalesLineChart from "./total-sales-line-chart";
import PageDomain from "./domain";
import MonthlyTargetPerformanceChart from "./monthly-target-performance-chart";
import DailySalesTable from "./daily-sales-table";

const SalesDashbaord = () => {
  const [orderedSalesMap, setOrderedSalesMap] = React.useState({});

  React.useEffect(() => {
    PageDomain.initializeDashboard()
      .then(() => {
        const dailySalesMap = PageDomain.calculateDailySalesMap();
        setOrderedSalesMap(dailySalesMap);
      })
      .catch((error) => {
        console.log("[Error][SalesDashboard][init] ", error);
      });
  }, []);

  return (
    <LayoutTemplate mainTitle="Dashboard" subTitle="Sales">
      <Grid
        container
        direction="column"
        className="sales-dashobaord-page"
        justifyContent="center"
      >
        <Grid container direction="row" className="gap-x-16 flex-no-wrap">
          <Grid item className="flex-1 p-8">
            <DailySalesTable orderedSalesMap={orderedSalesMap} />
          </Grid>
          <Grid item className="flex-1 p-8">
            <MonthlyTargetPerformanceChart orderedSalesMap={orderedSalesMap} />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <TotalSalesLineChart orderedSalesMap={orderedSalesMap} />
        </Grid>
      </Grid>
    </LayoutTemplate>
  );
};

export default SalesDashbaord;
